module.exports = __webpack_public_path__ + "static/img/hua10.8eb7d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua10.png
// module id = Jtae
// module chunks = 22